import React, { useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToolbarContext } from '../../contexts/toolbar-context';
import { useUserContext } from '../../contexts/user-context';
import { Card, CardActionArea, CardContent, CardHeader, Grid, Typography } from "@mui/material";


type ReportEntry = {
  link: string,
  title: string,
  more: string
}
const data = [
  { link: '/settings/options', title: 'Options', more: 'Management of global system options', permission: 'options.view' },
  { link: '/settings/roles', title: 'Roles', more: 'User roles and permissions', permission: 'roles.view' },
  { link: '/settings/sales-teams', title: 'Sales Teams', more: 'Sales teams (and standalone companies)', permission: 'salesteams.view' },
  { link: '/settings/exchange-rates', title: 'Exchange Rates', more: 'Manage exchange rates', permission: 'exchangerates.view' },
  { link: '/settings/users', title: 'User management', more: 'Users for this system', permission: 'users.view' },
  { link: '/settings/currencies', title: 'Currencies', more: 'Manage currencies', permission: 'currencies.view' }
];
data.sort((a: ReportEntry, b: ReportEntry) => { if (a.title < b.title) return -1; if (a.title > b.title) return 1; return 0; });

export const Settings = () => {
  const navigate = useNavigate();
  const toolbarContext = useContext(ToolbarContext);
  const user = useUserContext();
  const location = useLocation();
  const goto = (loc) => () => {
    navigate(loc);
  }
  useEffect(() => {
    toolbarContext.setPrimary(
      {
        primary: [],
        title: 'Settings',
        primaryUrl: location.pathname
      });
  }, []);

  return (
    <div className="settings is-scrollable">
      <Grid container spacing={2}>
        {
          data.map((item) => {
            if (item.permission && !user.hasPermission(item.permission)) return null;
            return (
              <Grid key={item.link} item md={3} xs={12}>
                <Card>
                  <CardActionArea onClick={goto(item.link)}>
                    <CardHeader title={item.title} variant="h5" sx={{ paddingBottom: 0 }} />
                    <CardContent>
                      {item.more}
                    </CardContent>
                  </CardActionArea>
                </Card>
              </Grid>
            );
          })
        }
      </Grid>
    </div>
  );
}
